import { actionTypes, ICNDDistrictState } from 'src/ducks/cnd-district.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getCNDDistrictsStatus = (
  state: ICNDDistrictState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
